module.exports = __webpack_public_path__ + "static/5-efe5cca3267b8e4abf060ad490629a90.jpg";